__turbopack_context__.v({
  "container": "index-module-scss-module__h4D1wa__container",
  "spaceContainer": "index-module-scss-module__h4D1wa__spaceContainer",
  "total": "index-module-scss-module__h4D1wa__total",
});
